import * as React from "react";

// types
import { SplitPayMethodValues } from "@payment-client/interfaces/SplitPay";

export interface PaymentPayContextValue {
    withCoupon: boolean;
    setWithCoupon: (use: boolean) => void;
    selectedSplitPayMethods: string;
    setSplitPayMethods: (paymentCodeList: string) => void;
    withSplitPay: boolean;
    paymentPageOfferEnabled?: boolean;
    billTotal: number;
    amountToPay: number;
    showSplitPay: boolean;
    amountToPayWithoutCouponWithoutSplitpay: number;
    rewardsEnabled: boolean;
}

export const PaymentPayContext = React.createContext<PaymentPayContextValue>({
    withCoupon: true,
    withSplitPay: true,
    paymentPageOfferEnabled: false,
    setWithCoupon: () => void 0,
    selectedSplitPayMethods: SplitPayMethodValues.DEFAULT,
    setSplitPayMethods: () => void 0,
    billTotal: 0,
    amountToPay: 0,
    showSplitPay: true,
    amountToPayWithoutCouponWithoutSplitpay: 0,
    rewardsEnabled: false,
});

if (__DEV__) {
    PaymentPayContext.displayName = "PaymentPayContext";
}
